"use client"

import { NewsletterPopup as NewsletterPopupData } from "@/api/generated/BMWInterfaces"
import NewsletterPopup from "./NewsletterPopup"
import { ResolvedNewsletterPopup, resolvePopup } from "./newsletterContent"
import { markRegistered } from "./newsletterSuppression"
import { useNewsletterPopup } from "./useNewsletterPopup"

// Split out so the trigger timers only mount when there is a popup to show — the hook stamps
// the once-per-day cookie on open, which would otherwise be spent on nothing.
const NewsletterPopupHost = ({
  content,
}: {
  content: ResolvedNewsletterPopup
}): React.ReactElement => {
  const { isOpen, source, close } = useNewsletterPopup()

  const handleSuccess = (): void => {
    markRegistered()
    close()
  }

  return (
    <NewsletterPopup
      open={isOpen}
      source={source}
      content={content}
      onClose={close}
      onSuccess={handleSuccess}
    />
  )
}

const NewsletterPopupController = ({
  content,
}: {
  content: NewsletterPopupData | null
}): React.ReactElement | null => {
  const resolved = resolvePopup(content)
  if (!resolved) return null
  return <NewsletterPopupHost content={resolved} />
}

export default NewsletterPopupController
